import React, { useState, useEffect } from "react";
import "../assets/css/customcss.css";
import { useLocation , useNavigate } from "react-router-dom";
import axios from 'axios';
import apiConfig from "../config/apiConfig";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moment from "jalali-moment"
import { RingLoader } from "react-spinners"
import { Card, CardHeader, CardBody, Row, Col, Button, Input, FormGroup, Label } from "reactstrap";
// Import utility functions
import { processFormattedData, calculateMealCaloriesForDailyRecord } from "../utils/foodDataProcessor";
import { generateMealMenu } from "../utils/menuGenerator";
import { generateDairyQuota, generateOliveOilQuota, generateSugarOrNutsQuota, generateSugarQuotaMenu, generateNutsQuotaMenu } from "../utils/quotaGenerator";
import { shouldGenerateAdditionalMeal } from "../utils/additionalMealGenerator";

function EditUserInfo() {
  const [user, setUser] = useState({});
  const [anthropometry, setAnthropometry] = useState({});
  const [dietOrder, setDietOrder] = useState({});
  const [dietOrder2, setDietOrder2] = useState([]);
  const [weeklyDate, setWeeklyDate] = useState();
  const serverUrl = apiConfig.serverUrl;
  const [showPopup, setShowPopup] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const location = useLocation();
  const [percentBreakfast, setPercentBreakfast] = useState()
  const [percentAfterBreakfas, setPercentAfterBreakfas] = useState()
  const [percentMorningSnack, setPercentMorningSnack] = useState()
  const [percentLunch, setPercentLunch] = useState()
  const [percentAfterLunch, setPercentAfterLunch] = useState()
  const [percentEveningSnack, setPercentEveningSnack] = useState()
  const [percentDinner, setPercentDinner] = useState()
  const [percentNightSnack, setPercentNightSnack] = useState()
  const [textFoodLunch, setTextFoodLunch] = useState('')
  const [textFoodBreakfast, setTextFoodBreakfast] = useState('')
  const [textFoodEveningsnack, setTextFoodEveningsnack] = useState('')
  const [textFoodMorningsnack, setTextFoodMorningsnack] = useState('')
  const [textFoodDinner, setTextFoodDinner] = useState('')
  const [textFoodNightSnack, setTextFoodNightSnack] = useState('')
  const [changeTypeDiet, setchangeTypeDiet] = useState(0)
  const [refLoad, setRefLoad] = useState()
  const userid = location.state.userid;
  const navigate = useNavigate();


const [walletAmount, setWalletAmount] = useState("");
const [isButtonDisabled, setIsButtonDisabled] = useState(false);
const [reservationCount, setReservationCount] = useState("");
const [isReserving, setIsReserving] = useState(false);





const [paymentMethod, setPaymentMethod] = useState("");

const [totalCalorieStatus, setTotalCalorieStatus] = useState(1);
const handleReservation = () => {

  setIsReserving(true);

  const formData4 = new FormData();
  formData4.append('id', user.id);
  formData4.append('reservationCount', reservationCount);

  axios
    .post(serverUrl + 'determine-reservation-panel', formData4)
    .then((response) => {
      toast.success('رزرو مشاوره برای کاربر ثبت شد');
      setReservationCount()
    })
    .catch((error) => {
      console.error(error);
      setReservationCount()
    })
    .finally(() => {
      // فعال کردن مجدد دکمه پس از اتمام درخواست
      setIsReserving(false)
    });



  
};


const [popupOpen, setPopupOpen] = useState(false);
const [selectedDays, setSelectedDays] = useState([]);
const [daysInFirstArrayState, setDaysInFirstArrayState] = useState([]);
const [daysInSecondArrayState, setDaysInSecondArrayState] = useState([]);
const [errorMessage, setErrorMessage] = useState("");

// categoryMap حذف شد - استفاده مستقیم از foodmenu_text به عنوان category (مطابق myFavMenu.jsx)

// تاریخچه منوهای انتخاب شده
const [selectedMenusHistory, setSelectedMenusHistory] = useState({
  daily: [],
  weekly: {},
  weekStart: moment().startOf('week').format('YYYY/MM/DD')
});

useEffect(() => {
  setRefLoad(0)
  const Usertoken = {
    headers: {
      userid: userid,
    },
  };

  axios
    .get(serverUrl + "get-user-info", Usertoken)
    .then((response) => {
      setUser(response.data.User || {});
      const DietOrder = response.data.DietOrder
      const DietMethod = response.data.DietMethod
      const FoodMenu = response.data.FoodMenu
      const OutputInformation = response.data.OutputInformation
      setDietOrder2(DietOrder)
      setWeeklyDate(OutputInformation.weekly_date)
      


      if(DietOrder)
      {
        if(DietOrder.type_of_diet == 'increase')
        {
          var type_diet = 'رژیم افزایش'
        }
        else if(DietOrder.type_of_diet == 'decrease')
        {
          var type_diet = 'رژیم کاهش'
        }
        else
        {
          var type_diet = 'رژیم ثبات'
        }
        var percent_breakfast = DietOrder.percent_breakfast
        var percent_afterbreakfas = DietOrder.percent_afterbreakfas
        var percent_morningsnack = DietOrder.percent_morningsnack
        var percent_lunch = DietOrder.percent_lunch
        var percent_afterlunch = DietOrder.percent_afterlunch
        var percent_eveningsnack = DietOrder.percent_eveningsnack
        var percent_dinner = DietOrder.percent_dinner
        var percent_nightsnack = DietOrder.percent_nightsnack
        var percent_quota1 = DietOrder.percent_quota1
        var percent_quota2 = DietOrder.percent_quota2
        var percent_quota3 = DietOrder.percent_quota3
      }
      else
      {
        var type_diet = null
        var percent_breakfast = 0
        var percent_afterbreakfas = 0
        var percent_morningsnack = 0
        var percent_lunch = 0
        var percent_afterlunch = 0
        var percent_eveningsnack = 0
        var percent_dinner = 0
        var percent_nightsnack = 0
      }

      if(DietMethod)
      {
        var dietmethod_text = DietMethod.dietmethod_text
        if(dietmethod_text == 'رژیم غذایی 5 : 2')
        {
          setTotalCalorieStatus(2)
        }
        else
        {
          setTotalCalorieStatus(1)
        }
      }
      else
      {
        var dietmethod_text = null
        
      }

      if(FoodMenu)
      {
        var foodmenu_text = FoodMenu.foodmenu_text
      }
      else
      {
        var foodmenu_text = null
      }

   

      if(OutputInformation)
      {
        if(OutputInformation.weight_loss_diet_calories1 == 0 && OutputInformation.weight_loss_diet_calories2 == 0)
        {
          var total_calories = OutputInformation.weight_loss_diet_calories
          var daily_quota = OutputInformation.daily_quota

          var total_calories1 = 0
          var total_calories2 = 0
          var daily_quota1 = 0
          var daily_quota2 = 0
        }
        else
        {
          var total_calories1 = OutputInformation.weight_loss_diet_calories1
          var total_calories2 = OutputInformation.weight_loss_diet_calories2
          var daily_quota1 = OutputInformation.daily_quota1
          var daily_quota2 = OutputInformation.daily_quota2

          var total_calories = 0
          var daily_quota = 0
        }
      }
      else
      {
        var total_calories = null
        var total_calories1 = null
        var total_calories2 = null
      }

      if(total_calories != 0)
      {
        var breakfastCalories = (total_calories * percent_breakfast) / 100;
        var afterbreakfasCalories = (total_calories * percent_afterbreakfas) / 100;
        var morningsnackCalories = (total_calories * percent_morningsnack) / 100;
        var lunchCalories = (total_calories * percent_lunch) / 100;
        var afterlunchCalories = (total_calories * percent_afterlunch) / 100;
        var eveningsnackCalories = (total_calories * percent_eveningsnack) / 100;
        var dinnerCalories = (total_calories * percent_dinner) / 100;
        var nightsnackCalories = (total_calories * percent_nightsnack) / 100;

        var quota1Calories = (daily_quota * percent_quota1) / 100;
        var quota2Calories = (daily_quota * percent_quota2) / 100;
        var quota3Calories = (daily_quota * percent_quota3) / 100;
      }
      else
      {
        var breakfastCalories = (total_calories2 * percent_breakfast) / 100;
        var afterbreakfasCalories = (total_calories2 * percent_afterbreakfas) / 100;
        var morningsnackCalories = (total_calories2 * percent_morningsnack) / 100;
        var lunchCalories = (total_calories2 * percent_lunch) / 100;
        var afterlunchCalories = (total_calories2 * percent_afterlunch) / 100;
        var eveningsnackCalories = (total_calories2 * percent_eveningsnack) / 100;
        var dinnerCalories = (total_calories2 * percent_dinner) / 100;
        var nightsnackCalories = (total_calories2 * percent_nightsnack) / 100;

        var quota1Calories = (daily_quota2 * percent_quota1) / 100;
        var quota2Calories = (daily_quota2 * percent_quota2) / 100;
        var quota3Calories = (daily_quota2 * percent_quota3) / 100;
      }

   

      setDietOrder(
      {
        foodmenu_text : FoodMenu.foodmenu_text,
        dietmethod_text : DietMethod.dietmethod_text,
        total_calories : total_calories,
        total_calories1 : total_calories1,
        total_calories2 : total_calories2,
        type_diet : type_diet,
        daily_quota : daily_quota,
        daily_quota1 : daily_quota1,
        daily_quota2 : daily_quota2,
        percent_breakfast : percent_breakfast,
        percent_afterbreakfas : percent_afterbreakfas,
        percent_morningsnack : percent_morningsnack,
        percent_lunch : percent_lunch,
        percent_afterlunch : percent_afterlunch,
        percent_eveningsnack : percent_eveningsnack,
        percent_dinner : percent_dinner,
        percent_nightsnack : percent_nightsnack,
        percent_quota1 : percent_quota1,
        percent_quota2 : percent_quota2,
        percent_quota3 : percent_quota3,
        quota1Calories : quota1Calories,
        quota2Calories : quota2Calories,
        quota3Calories : quota3Calories,
        breakfastCalories : breakfastCalories,
        afterbreakfasCalories : afterbreakfasCalories,
        morningsnackCalories : morningsnackCalories,
        lunchCalories : lunchCalories,
        afterlunchCalories : afterlunchCalories,
        eveningsnackCalories : eveningsnackCalories,
        dinnerCalories : dinnerCalories,
        nightsnackCalories : nightsnackCalories,
      }
      );
      
    })
    .catch((error) => console.error(error));
}, [userid,refLoad]);


if(dietOrder2)
{
  var start_date_en  = dietOrder2.start_date_en
}
else
{
  var start_date_en  = ''
}

const startDate = moment(weeklyDate != null ? weeklyDate : start_date_en, "YYYY/MM/DD");

const days = [...Array(7)].map((_, index) =>
  startDate.clone().add(index, "days")
);

const togglePopup = () => {
  setPopupOpen(!popupOpen);
};

const handleDaySelect = (day) => {
  // تبدیل تاریخ شمسی به میلادی
  const formattedDay = moment(day, "YYYY/MM/DD").format("YYYY/MM/DD"); // تبدیل تاریخ به فرمت میلادی

  if (selectedDays.includes(formattedDay)) {
    setSelectedDays(selectedDays.filter((selected) => selected !== formattedDay));
    setErrorMessage(""); // پاک کردن پیام خطا در صورت وجود
    return;
  }

  if (selectedDays.length === 1) {
    const firstSelectedDay = moment(selectedDays[0], "YYYY/MM/DD"); // تبدیل اولین تاریخ به میلادی
    const secondSelectedDay = moment(formattedDay, "YYYY/MM/DD"); // تبدیل تاریخ انتخابی به میلادی
    const difference = secondSelectedDay.diff(firstSelectedDay, "days");

    if (difference < 3) {
      setErrorMessage(
        "لطفا بین روزهای رژیم کاهش وزنتان 2 روز فاصله بیندازید مثلا دوشنبه و پنج شنبه"
      );
      return;
    }
  }

  if (selectedDays.length < 2) {
    setSelectedDays([...selectedDays, formattedDay]);
    setErrorMessage(""); // حذف پیام خطا در صورت انتخاب صحیح
  }
};
const handleConfirm = () => {
    
  const allDays = days.map((day) => day.format("YYYY/MM/DD"));

 
  const remainingDays = allDays.filter((day) => !selectedDays.includes(day));

  
  setDaysInFirstArrayState(selectedDays);

 
  setDaysInSecondArrayState(remainingDays);

  
  handleFormSubmit({ selectedDays, remainingDays });

  // بستن پاپ‌آپ
  setPopupOpen(false);
};

const handleWalletCharge = () => {
  
  setIsButtonDisabled(true);

  const formData4 = new FormData();
  formData4.append('id', user.id);
  formData4.append('price', walletAmount);

  axios
    .post(serverUrl + 'wallet-charge-user-panel', formData4)
    .then((response) => {
      toast.success('کیف پول کاربر با موفقیت شارژ شد');
      setWalletAmount()
    })
    .catch((error) => {
      console.error(error);
      setWalletAmount()
    })
    .finally(() => {
      // فعال کردن مجدد دکمه پس از اتمام درخواست
      setIsButtonDisabled(false);
    });
};

  function customRound(num) {
    const integerPart = Math.floor(num);   // قسمت صحیح عدد
    const decimalPart = num - integerPart; // قسمت اعشاری عدد
  
    if (decimalPart < 0.1) {
        return integerPart; // به نزدیک‌ترین عدد صحیح به پایین
    } else if (decimalPart >= 0.1 && decimalPart < 0.4) {
        return integerPart; // به نزدیک‌ترین عدد صحیح به پایین
    } else if (decimalPart >= 0.4 && decimalPart < 0.8) {
        return integerPart + 0.5; // به نزدیک‌ترین مضرب 0.5
    } else {
        return integerPart + 1; // به نزدیک‌ترین عدد صحیح به بالا
    }
  }
  
  
  function customRound2(num) {
    // گرد کردن عدد به نزدیک‌ترین عدد صحیح
    const roundedNum = Math.round(num);
    const remainder = roundedNum % 10;
  
    // حالا بر اساس قوانین شما عمل می‌کنیم
    let result;
    if (roundedNum < 3) {
      result = 1; // اعداد کمتر از 3 به 1 گرد می‌شوند
    } else if (remainder < 3) {
      result = roundedNum - remainder; // نزدیک‌ترین مضرب 10 به پایین
    } else if (remainder < 8) {
      result = Math.floor(roundedNum / 10) * 10 + 5; // نزدیک‌ترین مضرب 5
    } else {
      result = Math.ceil(roundedNum / 10) * 10; // نزدیک‌ترین مضرب 10 به بالا
    }
    
    return result.toString(); // تبدیل خروجی به رشته
  }
  
  
  
  function categorizeFraction(value) {
    if (value >= 0 && value < 0.25) {
        return "یک چهارم";
    } else if (value >= 0.25 && value < 0.5) {
        return "نیم";
    } else if (value >= 0.5 && value < 0.75) {
        return "سه چهارم";
    } else if (value >= 0.75 && value < 1) {
        return "یک";
    } else if (value >= 1 && value < 1.25) {
        return "یک و یک چهارم";
    } else if (value >= 1.25 && value < 1.5) {
        return "یک و نیم";
    } else if (value >= 1.5 && value < 1.75) {
        return "یک و سه چهارم";
    } else if (value >= 1.75 && value < 2) {
        return "دو";
    } else if (value >= 2 && value < 2.25) {
        return "دو و یک چهارم";
    } else if (value >= 2.25 && value < 2.5) {
        return "دو و نیم";
    } else if (value >= 2.5 && value < 2.75) {
        return "دو و سه چهارم";
    } else if (value >= 2.75 && value <= 3) {
        return "سه";
    } else {
        return "خارج از محدوده";
    }
  }

  


 
  const handleInputChange = (e, section) => {
    const { name, value } = e.target;
    if (section === "user") {
      setUser((prev) => ({ ...prev, [name]: value }));
    } else if (section === "anthropometry") {
      setAnthropometry((prev) => ({ ...prev, [name]: value }));
    } else if (section === "dietOrder") {
      setDietOrder((prev) => ({ ...prev, [name]: value }));
      if([name] == 'dietmethod_text' && value == 'رژیم غذایی 5 : 2')
      {
        setchangeTypeDiet(1)
      }
      else if([name] == 'dietmethod_text')
      {
        setchangeTypeDiet(0)
      }
     
      if([name] == 'percent_breakfast')
      {
        if(dietOrder.total_calories != 0)
        {
          const breakfastCalories = (dietOrder.total_calories * value) / 100;
        setDietOrder((prev) => ({ ...prev, 'breakfastCalories': breakfastCalories }));
        }
        else
        {
          const breakfastCalories = (dietOrder.total_calories2 * value) / 100;
          setDietOrder((prev) => ({ ...prev, 'breakfastCalories': breakfastCalories }));
        }
        
      }
      else if([name] == 'percent_afterbreakfas')
      {
        if(dietOrder.total_calories != 0)
        {
          const afterbreakfasCalories = (dietOrder.total_calories * value) / 100;
        setDietOrder((prev) => ({ ...prev, 'afterbreakfasCalories': afterbreakfasCalories }));
        }
        else
        {
          const afterbreakfasCalories = (dietOrder.total_calories2 * value) / 100;
          setDietOrder((prev) => ({ ...prev, 'afterbreakfasCalories': afterbreakfasCalories }));
        }
      }
      else if([name] == 'percent_morningsnack')
      {
        if(dietOrder.total_calories != 0)
        {
          const morningsnackCalories = (dietOrder.total_calories * value) / 100;
        setDietOrder((prev) => ({ ...prev, 'morningsnackCalories': morningsnackCalories }));
        }
        else
        {
          const morningsnackCalories = (dietOrder.total_calories2 * value) / 100;
          setDietOrder((prev) => ({ ...prev, 'morningsnackCalories': morningsnackCalories }));
        }
      }
      else if([name] == 'percent_lunch')
      {
        if(dietOrder.total_calories != 0)
        {
          const lunchCalories = (dietOrder.total_calories * value) / 100;
        setDietOrder((prev) => ({ ...prev, 'lunchCalories': lunchCalories }));
        }
        else
        {
          const lunchCalories = (dietOrder.total_calories2 * value) / 100;
          setDietOrder((prev) => ({ ...prev, 'lunchCalories': lunchCalories }));
        }
      }
      else if([name] == 'percent_afterlunch')
      {
        if(dietOrder.total_calories != 0)
        {
          const afterlunchCalories = (dietOrder.total_calories * value) / 100;
        setDietOrder((prev) => ({ ...prev, 'afterlunchCalories': afterlunchCalories }));
        }
        else
        {
          const afterlunchCalories = (dietOrder.total_calories2 * value) / 100;
          setDietOrder((prev) => ({ ...prev, 'afterlunchCalories': afterlunchCalories }));
        }
      }
      else if([name] == 'percent_eveningsnack')
      {
        if(dietOrder.total_calories != 0)
        {
          const eveningsnackCalories = (dietOrder.total_calories * value) / 100;
        setDietOrder((prev) => ({ ...prev, 'eveningsnackCalories': eveningsnackCalories }));
        }
        else
        {
          const eveningsnackCalories = (dietOrder.total_calories2 * value) / 100;
          setDietOrder((prev) => ({ ...prev, 'eveningsnackCalories': eveningsnackCalories }));
        }
      }
      else if([name] == 'percent_dinner')
      {
        if(dietOrder.total_calories != 0)
        {
          const dinnerCalories = (dietOrder.total_calories * value) / 100;
        setDietOrder((prev) => ({ ...prev, 'dinnerCalories': dinnerCalories }));
        }
        else
        {
          const dinnerCalories = (dietOrder.total_calories2 * value) / 100;
          setDietOrder((prev) => ({ ...prev, 'dinnerCalories': dinnerCalories }));
        }
      }
      else if([name] == 'percent_nightsnack')
      {
        if(dietOrder.total_calories != 0)
        {
          const nightsnackCalories = (dietOrder.total_calories * value) / 100;
        setDietOrder((prev) => ({ ...prev, 'nightsnackCalories': nightsnackCalories }));
        }
        else
        {
          const nightsnackCalories = (dietOrder.total_calories2 * value) / 100;
          setDietOrder((prev) => ({ ...prev, 'nightsnackCalories': nightsnackCalories }));
        }
      }
      else if([name] == 'percent_quota1')
      {
        if(dietOrder.daily_quota != 0)
        {
          const quota1Calories = (dietOrder.daily_quota * value) / 100;
          setDietOrder((prev) => ({ ...prev, 'quota1Calories': quota1Calories }));
        }
        else
        {
          const quota1Calories = (dietOrder.daily_quota2 * value) / 100;
          setDietOrder((prev) => ({ ...prev, 'quota1Calories': quota1Calories }));
        }
      }
      else if([name] == 'percent_quota2')
      {
        if(dietOrder.daily_quota != 0)
        {
          const quota2Calories = (dietOrder.daily_quota * value) / 100;
          setDietOrder((prev) => ({ ...prev, 'quota2Calories': quota2Calories }));
        }
        else
        {
          const quota2Calories = (dietOrder.daily_quota2 * value) / 100;
          setDietOrder((prev) => ({ ...prev, 'quota2Calories': quota2Calories }));
        }
      }
      else if([name] == 'percent_quota3')
      {
        if(dietOrder.daily_quota != 0)
        {
          const quota3Calories = (dietOrder.daily_quota * value) / 100;
          setDietOrder((prev) => ({ ...prev, 'quota3Calories': quota3Calories }));
        }
        else
        {
          const quota3Calories = (dietOrder.daily_quota2 * value) / 100;
          setDietOrder((prev) => ({ ...prev, 'quota3Calories': quota3Calories }));
        }
      }
    }
  };

  const handleFormSubmit = ({ selectedDays = [], remainingDays = [] } = {}) => {
    if(changeTypeDiet == 1)
    {
      setPopupOpen(true)
      setchangeTypeDiet(0)

    }
    else
    {

      const selectedDaysJson = JSON.stringify(selectedDays);
      const remainingDaysJson = JSON.stringify(remainingDays);
      
      if (selectedDaysJson) {
        var selected_days = selectedDaysJson
        
      } else {
       
        var selected_days = JSON.stringify([])
      }
      
      if (remainingDaysJson) {
       
        var remaining_days = remainingDaysJson
      } else {
        
        var remaining_days = JSON.stringify([])
      }



      const data = {
        user,
        anthropometry,
        dietOrder,
        selected_days,
        remaining_days
      };
  
      axios
        .post(serverUrl + "update-user-info", data, {
          headers: { userid: userid },
        })
        .then((response) => 
        {
          
          setShowPopup(true)
  
        }
        
        )
        .catch((error) => console.error("خطا در ویرایش اطلاعات:", error));
    }
    
  };


  const regimesystem = async () => 
 {
  setIsLoading(true)
  setRefLoad(1)
  
  try {
    // دریافت اطلاعات خروجی
    const Usertoken1 = {
      headers: {
        user_id: userid,
      },
    };

    // دریافت اطلاعات خروجی
    const outputResponse = await axios.get(serverUrl + "get-output-information-panel", Usertoken1);
    const information = outputResponse.data.OutputInformation;
    const DailyRecords = outputResponse.data.DailyRecords2;
    const DietOrder2 = outputResponse.data.DietOrder;
    const type_of_diet = DietOrder2?.type_of_diet || 'decrease';
    
    // دریافت منوها از API
    const foodMenuText = dietOrder.foodmenu_text || 'منوی رژیم غذایی متعادل و همه چیز خواری تمام فصول';
    // استفاده مستقیم از foodMenuText به عنوان category (مطابق myFavMenu.jsx)
    const category = foodMenuText;
    
    const foodListResponse = await axios.get(serverUrl + "get-food-list", {
      params: {
        category: category,
        include_portions: true,
        all2: true
      },
      headers: {
        userid: userid
      }
    });
    
    // پردازش داده‌های منو
    const formattedData = processFormattedData(foodListResponse.data.data || foodListResponse.data || []);
    
    // تاریخچه منوها
    let currentSelectedMenusHistory = selectedMenusHistory;
    const todaySelectedMenusRef = { menus: [] };
    const previousDaysMenus = [];
    
    const List = [];
    
    // تولید منو برای هر روز
    DailyRecords.forEach(element => {
      const currentDate = element.date;
      
      // محاسبه کالری‌های وعده‌ها
      const mealCalories = calculateMealCaloriesForDailyRecord({
        dailyRecord: element,
        outputInformation: information,
        dietOrder2: DietOrder2,
        dietOrder: type_of_diet,
        percentBreakfast: dietOrder.percent_breakfast,
        percentAfterBreakfast: dietOrder.percent_afterbreakfas,
        percentMorningSnack: dietOrder.percent_morningsnack,
        percentLunch: dietOrder.percent_lunch,
        percentAfterLunch: dietOrder.percent_afterlunch,
        percentEveningSnack: dietOrder.percent_eveningsnack,
        percentDinner: dietOrder.percent_dinner,
        percentNightSnack: dietOrder.percent_nightsnack
      });
      
      const {
        breakfastcal,
        afterbreakfastandlunchcal,
        morningsnackcal,
        lunchCal,
        afterlunchanddinnerCal,
        eveningsnackcal,
        dinnerCal,
        nightsnackcal,
        quotaCal1,
        quotaCal2,
        quotaCal3
      } = mealCalories;
      
      // تولید منوهای وعده‌ها
      let resultBreackfast = null;
      let resultMorningSnack = null;
      let resultLunch = null;
      let resultEveningSnack = null;
      let resultDinner = null;
      let resultNightSnack = null;
      let resultAfterbreakfast = null;
      let resultAfterlunch = null;
      let resultAfterDinner = null; // خوراکی خوشمزه بعد از شام (فقط برای increase)
      
      // صبحانه (مطابق ترتیب myFavMenu.jsx)
      if (breakfastcal && breakfastcal > 0) {
        const breakfastMenu = generateMealMenu(
          'صبحانه',
          breakfastcal,
          formattedData,
          currentSelectedMenusHistory,
          currentDate,
          (updatedHistory) => { currentSelectedMenusHistory = updatedHistory; },
          todaySelectedMenusRef,
          previousDaysMenus
        );
        if (breakfastMenu) {
          resultBreackfast = breakfastMenu.text;
        }
      }
      
      // بعد از صبحانه (فقط برای رژیم افزایش وزن - مطابق myFavMenu.jsx)
      if (shouldGenerateAdditionalMeal(type_of_diet) && afterbreakfastandlunchcal && afterbreakfastandlunchcal > 0) {
        const afterBreakfastMenu = generateMealMenu(
          'بعد از صبحانه',
          afterbreakfastandlunchcal,
          formattedData,
          currentSelectedMenusHistory,
          currentDate,
          (updatedHistory) => { currentSelectedMenusHistory = updatedHistory; },
          todaySelectedMenusRef,
          previousDaysMenus
        );
        if (afterBreakfastMenu) {
          resultAfterbreakfast = afterBreakfastMenu.text;
        }
      }
      
      // بعد از ناهار (فقط برای رژیم افزایش وزن - مطابق myFavMenu.jsx - قبل از ناهار!)
      if (shouldGenerateAdditionalMeal(type_of_diet) && afterlunchanddinnerCal && afterlunchanddinnerCal > 0) {
        const afterLunchMenu = generateMealMenu(
          'بعد از ناهار',
          afterlunchanddinnerCal,
          formattedData,
          currentSelectedMenusHistory,
          currentDate,
          (updatedHistory) => { currentSelectedMenusHistory = updatedHistory; },
          todaySelectedMenusRef,
          previousDaysMenus
        );
        if (afterLunchMenu) {
          resultAfterlunch = afterLunchMenu.text;
        }
      }
      
      // ناهار (مطابق ترتیب myFavMenu.jsx)
      if (lunchCal && lunchCal > 0) {
        const lunchMenu = generateMealMenu(
          'ناهار',
          lunchCal,
          formattedData,
          currentSelectedMenusHistory,
          currentDate,
          (updatedHistory) => { currentSelectedMenusHistory = updatedHistory; },
          todaySelectedMenusRef,
          previousDaysMenus
        );
        if (lunchMenu) {
          resultLunch = lunchMenu.text;
        }
      }
      
      // میان‌وعده صبح (مطابق ترتیب myFavMenu.jsx)
      if (morningsnackcal && morningsnackcal > 0) {
        const morningSnackMenu = generateMealMenu(
          'میان‌وعده صبح',
          morningsnackcal,
          formattedData,
          currentSelectedMenusHistory,
          currentDate,
          (updatedHistory) => { currentSelectedMenusHistory = updatedHistory; },
          todaySelectedMenusRef,
          previousDaysMenus
        );
        if (morningSnackMenu) {
          resultMorningSnack = morningSnackMenu.text;
        }
      }
      
      // میان‌وعده عصر
      if (eveningsnackcal && eveningsnackcal > 0) {
        const eveningSnackMenu = generateMealMenu(
          'میان‌وعده عصر',
          eveningsnackcal,
          formattedData,
          currentSelectedMenusHistory,
          currentDate,
          (updatedHistory) => { currentSelectedMenusHistory = updatedHistory; },
          todaySelectedMenusRef,
          previousDaysMenus
        );
        if (eveningSnackMenu) {
          resultEveningSnack = eveningSnackMenu.text;
        }
      }
      
      // شام
      if (dinnerCal && dinnerCal > 0) {
        const dinnerMenu = generateMealMenu(
          'شام',
          dinnerCal,
          formattedData,
          currentSelectedMenusHistory,
          currentDate,
          (updatedHistory) => { currentSelectedMenusHistory = updatedHistory; },
          todaySelectedMenusRef,
          previousDaysMenus
        );
        if (dinnerMenu) {
          resultDinner = dinnerMenu.text;
        }
      }
      
      // خوراکی خوشمزه بعد از شام (فقط برای رژیم افزایش وزن - مطابق myFavMenu.jsx)
      if (shouldGenerateAdditionalMeal(type_of_diet) && dinnerCal && dinnerCal > 0) {
        const afterDinnerMenu = generateMealMenu(
          'خوراکی خوشمزه بعد از شام',
          dinnerCal,
          formattedData,
          currentSelectedMenusHistory,
          currentDate,
          (updatedHistory) => { currentSelectedMenusHistory = updatedHistory; },
          todaySelectedMenusRef,
          previousDaysMenus
        );
        if (afterDinnerMenu) {
          resultAfterDinner = afterDinnerMenu.text;
        }
      }
      
      // میان‌وعده شب (بعد از شام) - برای همه رژیم‌ها (مطابق myFavMenu.jsx)
      if (nightsnackcal && nightsnackcal > 0) {
        const nightSnackMenu = generateMealMenu(
          'بعد از شام',
          nightsnackcal,
          formattedData,
          currentSelectedMenusHistory,
          currentDate,
          (updatedHistory) => { currentSelectedMenusHistory = updatedHistory; },
          todaySelectedMenusRef,
          previousDaysMenus
        );
        if (nightSnackMenu) {
          resultNightSnack = nightSnackMenu.text;
        }
      }
      
      // تولید سهمیه‌ها
      let resultDairyquota = null;
      let resultOliveOilSubstitute = null;
      let resultSugarSubstitute = null;
      let resultNutsSubstitute = null;
      
      // سهمیه لبنیات
      if (quotaCal1 && quotaCal1 > 0) {
        resultDairyquota = generateDairyQuota(quotaCal1, formattedData, type_of_diet);
      }
      
      // سهمیه روغن زیتون
      if (quotaCal2 && quotaCal2 > 0) {
        resultOliveOilSubstitute = generateOliveOilQuota(quotaCal2, formattedData);
      }
      
      // سهمیه قند یا آجیل (مطابق myFavMenu.jsx)
      if (quotaCal3 && quotaCal3 > 0) {
        if (type_of_diet === 'increase') {
          // برای رژیم افزایش وزن: سهمیه آجیل
          const nutsQuotaMenu = generateNutsQuotaMenu(
            quotaCal3,
            formattedData,
            null,
            currentSelectedMenusHistory,
            currentDate
          );
          if (nutsQuotaMenu) {
            resultNutsSubstitute = nutsQuotaMenu.text;
          }
        } else {
          // برای رژیم‌های کاهش وزن و ثبات: سهمیه قند
          const sugarQuotaMenu = generateSugarQuotaMenu(
            quotaCal3,
            formattedData,
            null,
            currentSelectedMenusHistory,
            currentDate
          );
          if (sugarQuotaMenu) {
            resultSugarSubstitute = sugarQuotaMenu.text;
          }
        }
      }
      
      // ساخت آرایه نهایی (مطابق ترتیب myFavMenu.jsx و بک‌اند)
      // ترتیب: [0: صبحانه, 1: میان‌وعده صبح, 2: ناهار, 3: میان‌وعده عصر, 4: شام, 5: بعد از شام, 
      //         6: سهمیه لبنیات, 7: سهمیه روغن, 8: سهمیه قند, 9: سهمیه آجیل, 
      //         10: بعد از صبحانه, 11: بعد از ناهار, 12: خوراکی خوشمزه بعد از شام]
      const array = [
        resultBreackfast,              // 0. صبحانه
        resultMorningSnack,            // 1. میان‌وعده صبح
        resultLunch,                   // 2. ناهار
        resultEveningSnack,            // 3. میان‌وعده عصر
        resultDinner,                  // 4. شام
        resultNightSnack,              // 5. بعد از شام (میان‌وعده شب)
        resultDairyquota,              // 6. سهمیه لبنیات
        resultOliveOilSubstitute,      // 7. سهمیه روغن زیتون
        resultSugarSubstitute,         // 8. سهمیه قند (برای decrease/stability)
        resultNutsSubstitute,          // 9. سهمیه آجیل (برای increase)
        resultAfterbreakfast,          // 10. بعد از صبحانه (فقط increase)
        resultAfterlunch,              // 11. بعد از ناهار (فقط increase)
        resultAfterDinner,             // 12. خوراکی خوشمزه بعد از شام (فقط increase)
      ];
      
      List.push(array);
      
      // اضافه کردن منوهای امروز به previousDaysMenus برای روز بعد
      previousDaysMenus.push(...todaySelectedMenusRef.menus);
      todaySelectedMenusRef.menus = [];
    });
    
    // به‌روزرسانی تاریخچه
    setSelectedMenusHistory(currentSelectedMenusHistory);
    
    // ارسال به سرور
    const jsonString = JSON.stringify(List);
    const formData4 = new FormData();
    formData4.append('user_id', userid);
    formData4.append('List', jsonString);
    
    await axios.post(serverUrl + 'daily-diet-push-records-panel', formData4);
    
    setShowPopup(false);
    setIsLoading(false);
    toast.success('اطلاعات با موفقیت ویرایش شد');
    
  } catch (error) {
    console.error('خطا در تولید منو:', error);
    setIsLoading(false);
    toast.error('خطا در تولید منو: ' + (error.response?.data?.message || error.message));
  }
};

const cancelregimesystem = () => 
{
 setShowPopup(false)
 
 toast.success('اطلاعات با موفقیت ویرایش شد');

}

  return (
    <>
     {/* لایه دارک زیر پاپ‌آپ */}
     {popupOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0, 0, 0, 0.5)",
            zIndex: 998,
          }}
        ></div>
      )}

      {/* پاپ‌آپ */}
      {popupOpen && (
        <div
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            background: "#fff",
            borderRadius: "20px",
            padding: "30px",
            boxShadow: "0 8px 16px rgba(0,0,0,0.4)",
            textAlign: "center",
            width: "450px",
            zIndex: 999,
          }}
        >
          <h3
            style={{
              fontFamily: "dana",
              fontWeight: "bold",
              fontSize: "20px",
              color: "#333",
            }}
          >
            کدام دو روز را مایل هستید رژیم کاهش وزن جدی داشته باشد؟
            (لطفا بین روزهای رژیم کاهش وزن 2 روز فاصله بیندازید مثلا دوشنبه
            و پنج شنبه)
          </h3>

          {errorMessage && (
            <p style={{ color: "red", fontFamily: "dana", marginTop: "10px" }}>
              {errorMessage}
            </p>
          )}

          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
              marginTop: "20px",
              gap: "10px",
              flexWrap: "wrap",
            }}
          >
            {days.map((day) => (
              <div
                key={day.format("YYYY/MM/DD")}
                onClick={() => handleDaySelect(day.format("YYYY/MM/DD"))}
                style={{
                  width: "70px",
                  height: "70px",
                  borderRadius: "10px",
                  background: selectedDays.includes(
                    day.format("YYYY/MM/DD")
                  )
                    ? "linear-gradient(45deg, #6fd642, #a4e887)"
                    : "#f0f0f0",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                  fontWeight: "bold",
                  fontSize: "14px",
                  color: selectedDays.includes(day.format("YYYY/MM/DD"))
                    ? "#fff"
                    : "#666",
                  boxShadow: selectedDays.includes(
                    day.format("YYYY/MM/DD")
                  )
                    ? "0 4px 8px rgba(0,0,0,0.2)"
                    : "none",
                  transition: "all 0.3s ease",
                }}
              >
                <div>{day.format("jD")}</div>
                <small
                  style={{
                    marginTop: "5px",
                    fontSize: "10px",
                    color: "#888",
                  }}
                >
                  {day.locale("en").format("DD")}
                </small>
              </div>
            ))}
          </div>

          <div
            style={{
              marginTop: "30px",
              display: "flex",
              gap: "10px",
              justifyContent: "center",
            }}
          >
            <button
              onClick={handleConfirm}
              disabled={selectedDays.length !== 2}
              style={{
                padding: "12px 30px",
                background:
                  selectedDays.length === 2
                    ? "linear-gradient(45deg, #6fd642, #a4e887)"
                    : "#ccc",
                border: "none",
                borderRadius: "25px",
                cursor: selectedDays.length === 2 ? "pointer" : "not-allowed",
                fontFamily: "dana",
                fontSize: "16px",
                color: "#fff",
                boxShadow:
                  selectedDays.length === 2
                    ? "0 4px 8px rgba(0,0,0,0.2)"
                    : "none",
                transition: "all 0.3s ease",
              }}
            >
              تایید
            </button>

            <button
              onClick={togglePopup}
              style={{
                padding: "12px 30px",
                background: "#f44",
                border: "none",
                borderRadius: "25px",
                cursor: "pointer",
                fontFamily: "dana",
                fontSize: "16px",
                color: "#fff",
                boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
                transition: "all 0.3s ease",
              }}
            >
              لغو
            </button>
          </div>
        </div>
      )}
    <ToastContainer /> 
    {isLoading ? (
      <div style={{display:'flex',justifyContent:'center',alignItems:'center', position:'fixed',width:'100%',height:'100%',backgroundColor:'#80808017'}}>
        <RingLoader  size='80px'  color="#36d7b7" />

      </div>
          )
          :(

          <div className="content">
          {showPopup && (
            <div className="popup-setting" style={{overflow : showPopup==true && 'auto'}}>
              <div style={{height:'170px',width:'400px'}}>
                  {/* <div>
                    <div onClick={togglePopup}><FontAwesomeIcon icon={faXmark} /></div>
                    <p>حذف حساب کاربری</p>
                    <div></div>
                  </div> */}

                  <img alt="" srcset="" />

                  <div style={{width:'300px'}}>
                    <p style={{color:'black'}}>منوهای غذایی با اطلاعات جدید بروزرسانی شود؟</p>
                  </div>

                  {/* <div>
                                      <p>درصورت حذف حساب کاربری
                      برنامه غذایی فعلی و سوابق تمامی خریدهای
                      شما حذف خواهد شد و قابل برگشت نیست.</p>
                  </div> */}

                  {/* <div>
                    <input type="checkbox" name="" id="" />
                    <p>مطمئنم پاکش کن!</p>
                  </div> */}

                  <div style={{display:'flex',justifyContent:'center'}}>
                    <button onClick={regimesystem} style={{
                      width:'150px',
                      height:'40px',
                      border:'unset',
                      outline:'unset',
                      borderRadius:'10px',
                      backgroundColor:'rgb(128 202 39 / 61%)',
                      margin:'0 15px',
                      color:'white',
                      fontFamily:'dana',
                      cursor:'pointer'
                    }}>بله</button>
                     <button onClick={cancelregimesystem} style={{
                      width:'150px',
                      height:'40px',
                      border:'unset',
                      outline:'unset',
                      borderRadius:'10px',
                      backgroundColor:'rgb(202 39 39 / 61%)',
                      margin:'0 15px',
                      color:'white',
                      fontFamily:'dana',
                      cursor:'pointer'
                    }}>خیر</button>
                    {/* <button
                    onClick={regimemanual}
                    style={{
                      width:'60px',
                      height:'40px',
                      border:'unset',
                      outline:'unset',
                      borderRadius:'10px',
                      backgroundColor:'red',
                      margin:'0 15px',
                      color:'white',
                      fontFamily:'dana',
                      cursor:'pointer'
                    }}>خیر</button> */}
                  </div>
              </div>
            </div>
          )}
            <Row>
              <Col md="12">
                <Card>
                  <CardHeader>
                    <h5 style={{ textAlign: "right" }} className="title">
                      ویرایش اطلاعات کاربر
                    </h5>
                  </CardHeader>
                  <CardBody>

                  <h3 style={{ textAlign: "right", marginTop: "40px" }}>شارژ کیف پول</h3>
                  <Row>
                    <Col md="6">
                      <FormGroup>
                        <Label>مبلغ شارژ (به دلار):</Label>
                        <Input
                          type="number"
                          name="wallet_amount"
                          placeholder="مثلاً 50000"
                          value={walletAmount || ""}
                          onChange={(e) => setWalletAmount(e.target.value)}
                        />
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup>
                        <Button
                          color="success"
                          onClick={handleWalletCharge}
                          style={{ float: "left", marginTop: "20px" }}
                          disabled={isButtonDisabled} // غیرفعال کردن دکمه هنگام ارسال درخواست
                        >
                          {isButtonDisabled ? 'در حال شارژ...' : 'شارژ کیف پول'} {/* نمایش متن مناسب */}
                        </Button>
                      </FormGroup>
                    </Col>
                  </Row>

                  {/* بخش تعیین رزرو برای کاربر */}
<h3 style={{ textAlign: "right", marginTop: "40px" }}>تعیین رزرو برای کاربر</h3>
<Row>
  <Col md="6">
    <FormGroup>
      <Label>تعداد رزرو:</Label>
      <Input
        type="number"
        name="reservation_count"
        placeholder="مثلاً 3"
        value={reservationCount || ""}
        onChange={(e) => setReservationCount(e.target.value)}
      />
    </FormGroup>
  </Col>
  <Col md="6">
    <FormGroup>
      <Button
        color="primary"
        onClick={handleReservation}
        style={{ float: "left", marginTop: "20px" }}
        disabled={isReserving}
      >
        {isReserving ? 'در حال ثبت...' : 'ثبت رزرو'}
      </Button>
    </FormGroup>
  </Col>
</Row>

                    <h3 style={{ textAlign: "right" }}>اطلاعات فردی</h3>
                    <Row>
                      <Col md="6">
                        <FormGroup>
                          <Label>نام:</Label>
                          <Input
                            type="text"
                            name="name"
                            value={user.name || ""}
                            onChange={(e) => handleInputChange(e, "user")}
                          />
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        <FormGroup>
                          <Label>نام خانوادگی:</Label>
                          <Input
                            type="text"
                            name="last_name"
                            value={user.last_name || ""}
                            onChange={(e) => handleInputChange(e, "user")}
                          />
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        <FormGroup>
                          <Label>شماره تلفن:</Label>
                          <Input
                            type="text"
                            name="phone_number"
                            value={user.phone_number || ""}
                            onChange={(e) => handleInputChange(e, "user")}
                          />
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        <FormGroup>
                          <Label>ایمیل:</Label>
                          <Input
                            type="email"
                            name="email"
                            value={user.email || ""}
                            onChange={(e) => handleInputChange(e, "user")}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  
                    <h3 style={{ textAlign: "right" }}>اطلاعات رژیم</h3>
                    <Row>

                    {/* <Col md="6">
                      <FormGroup>
                        <Label>نوع رژیم:</Label>
                        <Input
                          type="select"
                          name="foodmenu_text"
                          value={dietOrder.foodmenu_text || ""}
                          onChange={(e) => handleInputChange(e, "dietOrder")}
                        >
                          <option value="">انتخاب کنید</option>
                          <option value="عادی">عادی</option>
                          <option value="فستینگ">فستینگ</option>
                          <option value="2:5">2:5</option>
                         
                        </Input>
                      </FormGroup>
                    </Col> */}
                    <Col md="6">
                      <FormGroup>
                        <Label>روش رژیم غذایی:</Label>
                        <Input
                          type="select"
                          name="dietmethod_text"
                          value={dietOrder.dietmethod_text || ""}
                          onChange={(e) => handleInputChange(e, "dietOrder")}
                        >
                          <option value="">انتخاب کنید</option>
                          <option value="رژیم عادی">رژیم عادی</option>

                          {
                            dietOrder.type_diet == 'رژیم کاهش'
                            &&
                            <option value="رژیم فستینگ">رژیم فستینگ</option>
                          }
                          {
                            dietOrder.type_diet == 'رژیم کاهش'
                            &&
                            <option value="رژیم غذایی 5 : 2">رژیم غذایی 5 : 2</option>
                          }
                          
                          
                          
                        </Input>
                      </FormGroup>
                    </Col>

                    <Col md="6">
                      <FormGroup>
                        <Label>منوی غذایی:</Label>
                        <Input
                          type="select"
                          name="foodmenu_text"
                          value={dietOrder.foodmenu_text || ""}
                          onChange={(e) => handleInputChange(e, "dietOrder")}
                        >
                          <option value="">انتخاب کنید</option>
                          <option value="منوی رژیم غذایی متعادل و همه چیز خواری تمام فصول">منوی رژیم غذایی متعادل و همه چیز خواری تمام فصول</option>
                          <option value="منو رژیم غذایی گیاه خواری همراه با شیر و تخم مرغ">منو رژیم غذایی گیاه خواری همراه با شیر و تخم مرغ</option>
                          <option value="منو رژیم غذایی پر پروتئین">منو رژیم غذایی پر پروتئین</option>
                          <option value="منو رژیم غذایی متعادل و همه چیز خواری مختص فصول گرم">منو رژیم غذایی متعادل و همه چیز خواری مختص فصول گرم</option>
                          <option value="منو رژیم غذایی متعادل و همه چیز خواری مختص فصول سرد">منو رژیم غذایی متعادل و همه چیز خواری مختص فصول سرد</option>
                        </Input>
                      </FormGroup>
                    </Col>

                    {totalCalorieStatus == 2
                    &&
                 
                        <Col md="6">
                        <FormGroup>
                          <Label>کالری دو روز :</Label>
                          <Input
                            type="number"
                            name="total_calories1"
                            value={dietOrder.total_calories1 || ""}
                            onChange={(e) => handleInputChange(e, "dietOrder")}
                          />
                        </FormGroup>
                      </Col>
 
                    }


                    {totalCalorieStatus == 2
                      &&
                      <Col md="6">
                      <FormGroup>
                        <Label>سهمیه دو روز:</Label>
                        <Input
                          type="number"
                          name="daily_quota1"
                          value={dietOrder.daily_quota1 || ""}
                          onChange={(e) => handleInputChange(e, "dietOrder")}
                        />
                      </FormGroup>
                    </Col>
 
                     }



                  {totalCalorieStatus == 2
                    &&
                 
                    <Col md="6">
                    <FormGroup>
                      <Label>کالری پنج روز :</Label>
                      <Input
                        type="number"
                        name="total_calories2"
                        value={dietOrder.total_calories2 || ""}
                        onChange={(e) => handleInputChange(e, "dietOrder")}
                      />
                    </FormGroup>
                  </Col>
 
                    }

                  {totalCalorieStatus == 2
                      &&
                      <Col md="6">
                        <FormGroup>
                          <Label>سهمیه پنج روز:</Label>
                          <Input
                            type="number"
                            name="daily_quota2"
                            value={dietOrder.daily_quota2 || ""}
                            onChange={(e) => handleInputChange(e, "dietOrder")}
                          />
                        </FormGroup>
                      </Col>
 
                     }

                    

                  {totalCalorieStatus == 1
                                      &&

                                      <Col md="6">
                                      <FormGroup>
                                        <Label>کالری کل این جلسه:</Label>
                                        <Input
                                          type="number"
                                          name="total_calories"
                                          value={dietOrder.total_calories || ""}
                                          onChange={(e) => handleInputChange(e, "dietOrder")}
                                        />
                                      </FormGroup>
                                    </Col>
                  }





                      
                   

              

                    {totalCalorieStatus == 1
                      &&
                      
                      <Col md="6">
                        <FormGroup>
                          <Label>کالری کل سهمیه:</Label>
                          <Input
                            type="number"
                            name="daily_quota"
                            value={dietOrder.daily_quota || ""}
                            onChange={(e) => handleInputChange(e, "dietOrder")}
                          />
                        </FormGroup>
                      </Col>
 
                     }

                     


                      

                      <Col md="6">
                        <FormGroup>
                          <Label style={{display:'flex'}}>سهمیه لبنیات:<p>({dietOrder.quota1Calories + ' ' + 'کالری'})</p>
                          </Label>
                          <Input
                            type="number"
                            name="percent_quota1"
                            value={dietOrder.percent_quota1}
                            onChange={(e) => handleInputChange(e, "dietOrder")}
                          />
                        </FormGroup>
                      </Col>

                      <Col md="6">
                        <FormGroup>
                          <Label style={{display:'flex'}}>سهمیه روغن:<p>({dietOrder.quota2Calories + ' ' + 'کالری'})</p>
                          </Label>
                          <Input
                            type="number"
                            name="percent_quota2"
                            value={dietOrder.percent_quota2}
                            onChange={(e) => handleInputChange(e, "dietOrder")}
                          />
                        </FormGroup>
                      </Col>

                      <Col md="6">
                        <FormGroup>
                          <Label style={{display:'flex'}}>
                            {
                              dietOrder.type_diet == 'رژیم افزایش'
                              ?
                              'سهمیه آجیل:'
                              :
                              'سهمیه شکر:'
                            }
                           <p>({dietOrder.quota3Calories + ' ' + 'کالری'})</p>
                            
                          </Label>
                          <Input
                            type="number"
                            name="percent_quota3"
                            value={dietOrder.percent_quota3}
                            onChange={(e) => handleInputChange(e, "dietOrder")}
                          />
                        </FormGroup>
                      </Col>

                      <Col md="6">
                        <FormGroup>
                        
                          <Label style={{display:'flex'}}>درصد صبحانه: <p>({dietOrder.breakfastCalories + ' ' + 'کالری'})</p></Label>
                          <Input
                            type="number"
                            name="percent_breakfast"
                            value={dietOrder.percent_breakfast || ""}
                            onChange={(e) => handleInputChange(e, "dietOrder")}
                          />
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        <FormGroup>
                          <Label style={{display:'flex'}}>درصد بعد از صبحانه: <p>({dietOrder.afterbreakfasCalories + ' ' + 'کالری'})</p></Label>
                          <Input
                            type="number"
                            name="percent_afterbreakfas"
                            value={dietOrder.percent_afterbreakfas || ""}
                            onChange={(e) => handleInputChange(e, "dietOrder")}
                          />
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        <FormGroup>
                          <Label style={{display:'flex'}}>درصد میان وعده صبح: <p>({dietOrder.morningsnackCalories + ' ' + 'کالری'})</p></Label>
                          <Input
                            type="number"
                            name="percent_morningsnack"
                            value={dietOrder.percent_morningsnack || ""}
                            onChange={(e) => handleInputChange(e, "dietOrder")}
                          />
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        <FormGroup>
                          <Label style={{display:'flex'}}>درصد ناهار: <p>({dietOrder.lunchCalories + ' ' + 'کالری'})</p></Label>
                          <Input
                            type="number"
                            name="percent_lunch"
                            value={dietOrder.percent_lunch || ""}
                            onChange={(e) => handleInputChange(e, "dietOrder")}
                          />
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        <FormGroup>
                          <Label style={{display:'flex'}}>درصد بعد از ناهار: <p>({dietOrder.afterlunchCalories + ' ' + 'کالری'})</p></Label>
                          <Input
                            type="number"
                            name="percent_afterlunch"
                            value={dietOrder.percent_afterlunch || ""}
                            onChange={(e) => handleInputChange(e, "dietOrder")}
                          />
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        <FormGroup>
                          <Label style={{display:'flex'}}>درصد میان وعده عصر: <p>({dietOrder.eveningsnackCalories + ' ' + 'کالری'})</p></Label>
                          <Input
                            type="number"
                            name="percent_eveningsnack"
                            value={dietOrder.percent_eveningsnack || ""}
                            onChange={(e) => handleInputChange(e, "dietOrder")}
                          />
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        <FormGroup>
                          <Label style={{display:'flex'}}>درصد شام: <p>({dietOrder.dinnerCalories + ' ' + 'کالری'})</p></Label>
                          <Input
                            type="number"
                            name="percent_dinner"
                            value={dietOrder.percent_dinner || ""}
                            onChange={(e) => handleInputChange(e, "dietOrder")}
                          />
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        <FormGroup>
                          <Label style={{display:'flex'}}>درصد میان وعده شب: <p>({dietOrder.nightsnackCalories + ' ' + 'کالری'})</p></Label>
                          <Input
                            type="number"
                            name="percent_nightsnack"
                            value={dietOrder.percent_nightsnack || ""}
                            onChange={(e) => handleInputChange(e, "dietOrder")}
                          />
                        </FormGroup>
                      </Col>
              
                    </Row>
                    <Button
                      color="primary"
                      onClick={handleFormSubmit}
                      style={{ float: "left", marginTop: "20px" }}
                    >
                      ویرایش اطلاعات
                    </Button>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
          )
    }
    </>
  );
}

export default EditUserInfo;
